{
  "it": {
    "ticket": {
      "actions": {
        "assignCustomer": "Completa procedura",
        "bulk_assign_new_emp": "Assegna in blocco un nuovo responsabile",
        "close": "Chiudi",
        "create_new": "Crea nuova conversazione",
        "customer_new_ticket": "Nuova conversazione",
        "delete": "Elimina",
        "edit": "Modifica",
        "existing_conversation": "Conversazione esistente",
        "goToConversation": "Vai alla conversazione",
        "move_to_existing": "Sposta messaggio in una conversazione esistente",
        "new": "Conversazione",
        "new_aria_label": "Avvia una nuova conversazione",
        "new_conversation": "Nuova conversazione",
        "reopen": "Riapri",
        "selectResponsible": "Selezioni il responsabile",
        "selectUnit": "Selezioni un'unità",
        "show": "Mostra",
        "startNew": "Avvia una nuova conversazione"
      },
      "attributes": {
        "status": "Stato",
        "statuses": {
          "closed": "Chiusa",
          "feedback": "In attesa di risposta",
          "ongoing": "In corso",
          "open": "Aperta"
        },
        "title": "Titolo"
      },
      "editor": {
        "tooltips": {
          "bold": "Grassetto",
          "bulletList": "Elenco puntato",
          "highlight": "Evidenziatore",
          "italic": "Corsivo",
          "link": "Link",
          "orderedList": "Elenco numerato",
          "redo": "Ripeti",
          "strike": "Barrato",
          "textColor": "Colore testo",
          "underline": "Sottolineato",
          "undo": "Annulla",
          "unlink": "Rimuovi link"
        }
      },
      "labels": {
        "addFile": "Aggiungi file",
        "additionalQuestion": "Ha altre domande?",
        "all": "Tutte",
        "allProjects": "Tutti i progetti",
        "allUnits": "Tutte le unità",
        "assign_conversations": "Assegna conversazioni da",
        "bulk_assign_new_emp_warning": "Questo aggiornamento includerà anche le conversazioni collegate a decisioni o al post-vendita. Per le decisioni correlate (di queste conversazioni interessate), verrà aggiornato anche il dipendente responsabile.",
        "cantChangeResponsibleAftercare": "Questa conversazione è collegata a una segnalazione post-vendita. Modifichi il responsabile da lì.",
        "cantChangeResponsibleDecision": "Questa conversazione è collegata a una decisione. Modifichi il responsabile da lì.",
        "cantDelete": "Questa conversazione appartiene a una decisione e non può essere eliminata.",
        "cantEdit": "Questa conversazione appartiene a una decisione. La modifichi invece dalla decisione",
        "changeResponsible": "Modifica",
        "change_responsible": "Cambia responsabile delle conversazioni",
        "clientWillRespondSoon": "Le risponderemo il prima possibile",
        "contact": "Contatto",
        "contactPerson": "Il Suo referente",
        "contactPersonWithName": "Il Suo referente per {name}",
        "conversation_title": "Titolo conversazione",
        "conversations": "Conversazioni",
        "create_ticket": "Crea conversazione",
        "customer": "Cliente",
        "customers": "Clienti",
        "decision": "Quale decisione?",
        "decisionConversation": "Decisione",
        "decisionConversations": "Decisioni",
        "disabled_unit": "Questa unità è stata disattivata. Non è possibile inviare messaggi.",
        "documentAddedBy": "da",
        "documents": "Documenti",
        "email_forwarding": "Inoltro email",
        "employee": "Dipendente",
        "export_conversation": "Esporta conversazione",
        "files": "File",
        "filter": "Filtro",
        "inbound_by": "In entrata da {name}",
        "inbound_emails": "Email in arrivo",
        "info": "Una domanda a cui non ha trovato risposta nella sezione {faq_route}? La ponga qui. Cerchi di raggruppare le domande in argomenti di conversazione chiari, ad es. «Specifiche». ",
        "keywords": "Cerca contenuti",
        "lastMessage": "Ultimo messaggio",
        "message": "Messaggio",
        "message_placeholder": "Scriva qui il Suo messaggio...",
        "message_subtitle": "Descriva la Sua domanda o il Suo problema",
        "messaged_at_nulls_first_asc": "Attività meno recente",
        "messaged_at_nulls_last_desc": "Attività più recente",
        "myProjects": "I miei progetti",
        "myTickets": "Le mie conversazioni",
        "myTicketsTooltip": "Mostra solo le conversazioni di cui è responsabile",
        "name_lower_asc": "Titolo A -> Z",
        "name_lower_desc": "Titolo Z -> A",
        "newConversation": "Nuova conversazione",
        "newMessage": "Nuovo messaggio",
        "newMessages": "Nuovi messaggi",
        "newWithPartner": "Ziggu e {partner}",
        "newWithZiggu": "Solo Ziggu",
        "noCustomer": "Nessun cliente ancora assegnato o invitato",
        "noCustomerAssignedToUnit": "Nessun cliente assegnato a questa unità. Vuole continuare?",
        "noCustomerAssignedToUnitExplainer": "Nota: dovrà quindi selezionare un altro destinatario.",
        "noCustomerAssignedToUnit_SUP": "Nessun cliente assegnato a questo progetto. Vuole continuare?",
        "noCustomerInvited": "Il cliente assegnato a questa unità non è ancora stato invitato. Vuole continuare?",
        "noFiles": "Nessun file ancora caricato",
        "noMessagesYet": "Nessun messaggio ancora",
        "noTickets": "Nessuna conversazione",
        "no_messages": "La conversazione non ha messaggi",
        "notSeenYet": "Non ancora visualizzato",
        "notYetDetermined": "Non ancora stabilito",
        "note": "Nota",
        "note_placeholder": "Scriva solo ai membri del team. Digiti {'@'} per menzionare un membro del team, che riceverà una notifica.",
        "onlySelect": "Mostra solo",
        "orNewTicket": "Oppure ne apra una nuova su un altro argomento",
        "otherTickets": "Altre conversazioni del cliente",
        "participants": "1 partecipante | {count} partecipanti",
        "partner": "Partner",
        "partnerGroup": "Con chi desidera parlare?",
        "partnersDecision": "Partner della decisione",
        "pendingContactPerson": "Il Suo referente risponderà il prima possibile",
        "pendingTickets": "Nuovi messaggi",
        "project": "Progetto",
        "read": "Letto",
        "remove_inbound_email": "Rimuovere {email}?",
        "reply": "Rispondi",
        "reply_placeholder": "Scriva a tutti",
        "responsible": "Responsabile",
        "search": "Cerca",
        "search_conversation": "Cerca",
        "seen": "Visualizzato",
        "seenAll": "tutti",
        "seenBy": "Visualizzato da {name}",
        "selectLevel": "Seleziona livello",
        "selectUnit": "Selezioni un'unità",
        "show": "Visualizzazione",
        "showFiles": "Mostra file",
        "showTicketsFor": "Mostra conversazioni per",
        "showingAll": "Tutte le conversazioni",
        "sort": "Ordina per",
        "startConversation": "Avvia una nuova conversazione",
        "startConversationForProject": "Avvia una nuova conversazione nel progetto ",
        "startNewConversation": "Avvia una nuova conversazione",
        "subject": "Oggetto",
        "subject_subtitle": "Descriva in poche parole",
        "teamMember": "Membro del team",
        "ticketClosed": "Questa conversazione è stata chiusa.",
        "ticketClosedByResponsible": "Questa conversazione è stata chiusa da {responsible}",
        "ticketClosedCustomer": "Se ha un'altra domanda, apra una nuova conversazione.",
        "ticketClosedEmployee": "Se desidera riaprire la conversazione, modifichi lo stato qui sopra.",
        "ticket_category": "Categoria",
        "tickets_all_projects": "Conversazioni di tutti i progetti",
        "to": "a",
        "unit": "Unità",
        "unit_name_lower_asc": "Unità A -> Z",
        "unit_name_lower_desc": "Unità Z -> A",
        "unread": "Non letto",
        "upload_files": "1 file in attesa | {count} file in attesa",
        "warning_move_message_to_new_ticket": "Questo messaggio verrà spostato in una conversazione generale, che non sarà collegata a una decisione o a una segnalazione.",
        "withMentions": "Menzionato in",
        "withMessages": "Con messaggi",
        "writeMessageToBecomeResponsible": "Scriva un messaggio per diventare responsabile",
        "you": "Tu"
      },
      "messages": {
        "redirect_decision": "Questa conversazione fa parte di una decisione. Faccia clic qui per visualizzare la decisione.",
        "redirect_issue": "Questa conversazione fa parte del post-vendita. Faccia clic qui per andare al post-vendita.",
        "redirect_link": "Vedi dettagli"
      },
      "navigation": {
        "backToTickets": "Torna indietro"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Cerchi di raggruppare le domande in argomenti di conversazione generali, ad es. «Specifiche».",
            "title": "Una domanda? La ponga qui."
          },
          "none": {
            "title": "Nessuna conversazione trovata"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Avvii la Sua prima conversazione con qualcuno.",
            "title": "Qualcosa da chiedere?"
          },
          "none": {
            "subtitle": "Modifichi i filtri in alto nella pagina oppure inizi a seguire un progetto per trovare le conversazioni correlate",
            "subtitle_aftercare": "Faccia clic sui tre puntini di una segnalazione per avviare una conversazione",
            "title": "Nessuna conversazione trovata"
          }
        }
      },
      "toasts": {
        "responsible_bulk_update_started": "Il responsabile è in fase di modifica. Potrebbe richiedere alcuni minuti."
      },
      "validation": {
        "mustBeMaximum": "L'oggetto deve restare sotto i {number} caratteri.",
        "needCustomer": "Selezioni un cliente",
        "needMessage": "Messaggio obbligatorio",
        "needName": "Titolo obbligatorio",
        "needResponsible": "Selezioni un responsabile",
        "needSubject": "Oggetto obbligatorio",
        "needUnit": "Selezioni un'unità"
      }
    }
  }
}
